var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md all"},[_c('div',{staticClass:"in"},[_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.caption))]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }